import { Block } from "modules/Block";

import "./accordion-block.scss";

export class AccordionBlock extends Block<typeof AccordionBlock> {
    static readonly className: string = "js-accordion-block";

    private allAccordions?: NodeListOf<HTMLElement> | null;

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        this.allAccordions = rootElement.querySelectorAll<HTMLElement>(".js-accordion-expand");

        this.allAccordions.forEach((accordion) => {
            accordion.addEventListener("click", this.handleAccordionClick);
        });
    }

    private handleAccordionClick = (e: MouseEvent) => {
        const clickedAccordion = e.currentTarget;

        if (!(clickedAccordion instanceof Element)) return;

        const isActive = clickedAccordion?.classList.contains("active");

        this.allAccordions?.forEach((accordion) => {
            accordion.classList.remove("active");
            accordion.nextElementSibling?.setAttribute("aria-expanded", "false");
        });

        if (!isActive) {
            clickedAccordion.classList.add("active");
            clickedAccordion.nextElementSibling?.setAttribute("aria-expanded", "true");
        }
    }
}